import { Button, NumberInput } from "@mantine/core";
import { useFormRender } from "../hooks/useFormRender";
import { ENUM_FORM_DISPLAY } from "./pageList";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import RemoteSelect2 from "./remoteSelect2";
import { useState, useEffect, useMemo } from "react";
import { useFormatter } from "../hooks/useFomatter";

const ClientTransferCreditButton = ({ mainForm }) => {
  const { t } = useTranslation();
  const [api] = useServerApi();
  const [currentCredit, setCurrentCredit] = useState(0);
  const clientId = mainForm?.values?._id;
  const [formatter] = useFormatter();
  const fetchCredit = async () => {
    try {
      if (!clientId) return;
      const credit = await api.Client.getAvailableCredit(clientId);
      setCurrentCredit(credit.balance);
    } catch (error) {
      console.log("Error fetching credit:", error);
    }
  };

  useEffect(() => {
    fetchCredit();
  }, [clientId]);

  // Create dynamic form schema that updates when currentCredit changes
  const formSchema = useMemo(
    () => ({
      title: "Transfer Credit",
      display: {
        mode: ENUM_FORM_DISPLAY.MODAL,
        size: "1000px", //xs, sm, xl  ....100%
        // position:"right"
      },
      closeAfterSave: true,
      showSaveBar: true,
      apiEntity: "client",

      validate: {
        toClient: (value) => (!value ? "Please select To Client" : null),
        credit: (value) =>
          value <= 0 ? "Credit must be greater than 0" : null,
      },
      initialValues: {
        credit: currentCredit,
        toClient: null,
      },

      layout: {
        containers: [],
        fields: [
          {
            name: "credit",
            component: NumberInput,
            parent: "section-credit",
            props: {
              required: true,
              label: "Credit",
              placeholder: "Credit",
              parser: formatter.currencyParser,
              formatter: formatter.currencyFormat,
              precision: 2,
            },
          },
          {
            name: "toClient",
            component: RemoteSelect2,
            parent: "section-credit",
            props: {
              apiEntity: "client",
              required: true,
              placeholder: "Search Client By ID/ BR / Name ",
              valueField: "_id",
              labelField: "name",
              allowClear: true,
              labelRender: (data) =>
                `[ ${data.code ?? data.id ?? " -- "} ] ${data.name} ${
                  data.cname ? `(${data.cname})` : ""
                }`,
              //   labelRender: (data) => `${data.cname}`,
              multiple: false,
              // preQuery: { $and: [ {isConsultant : true}, {isActive: true} ] },
              // preQuery:  {isConsultant : true} ,
              searchFields: ["name", "id", "cname", "code"],
              clearable: true,
              sort: {
                by: "name",
                order: "asc",
              },
            },
          },
        ],
      },
    }),
    [currentCredit]
  );

  const handleActionClick = () => {
    const id = mainForm?.values?._id;
    if (!id) return;

    // Pass the current credit as initial data to the form
    const initialData = {
      credit: currentCredit,
      toClient: null,
    };

    formAction.open({ mode: "edit", id, data: initialData });
  };

  const transferCredit = async (toClient, credit) => {
    try {
      if (!toClient || !credit || !clientId) return;
      const response = await api.Client.transferCredit(
        clientId,
        toClient,
        credit
      );
      //   console.log("Credit updated:", response);
      mainForm.reload();
    } catch (error) {
      console.log("Error updating credit:", error);
    }
  };

  const onSubmit = ({ values, formMode }) => {
    try {
      //   console.log("onSubmit", values);
      transferCredit(values.toClient, values.credit);
    } catch (error) {
      console.log("Error transferring credit:", error);
    }
  };

  const onSubmitSuccess = () => {
    // console.log("onSubmitSuccess");
    formAction.close();
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    onSubmitSuccess,
    onSubmit
  );

  return (
    <>
      <Button
        fullWidth
        onClick={handleActionClick}
        disabled={currentCredit <= 0}
      >
        {t("Transfer Credit")}
      </Button>

      {renderForm()}
    </>
  );
};

export default ClientTransferCreditButton;
